import React from 'react';
import colors from '../../utils/colors';
import typography from '../../utils/typography';

const ModeSwitch = ({
  options = ['Chat', 'Custom'],
  selectedMode,
  onModeChange,
  className = ''
}) => {
  return (
    <div 
      className={`flex items-center h-10 gap-1 p-1 rounded-full border ${className}`}
      style={{ borderColor: colors.border.primary }}
    >
      {options.map((option) => (
        <div 
          key={option}
          className={`flex justify-center items-center h-full px-3 rounded-full cursor-pointer transition-all ${
            selectedMode === option ? "" : "hover:bg-white/5"
          }`}
          style={{
            backgroundColor: selectedMode === option ? colors.bg.tertiary : 'transparent'
          }}
          onClick={() => onModeChange?.(option)}
        >
          <p 
            className={`min-w-[42px] text-center`}
            style={{
              ...typography.small.title,
              color: colors.text.primary
            }}
          >
            {option}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ModeSwitch;